import React from 'react';
import type { HeaderBanner as HeaderBannerType } from 'types/ui/HeaderBanner';
import HeaderBanner from '../header2026/banner';

interface AnnouncementBannerProps {
  headerBanner?: HeaderBannerType | null;
}

/** The announcement banners for the site. It can render one hardcoded banner (if it's not commented out), and then one
 * dynamic banner based on the'headerBanner' prop. The 'headerProp' is likely to be the referral banner.
 */
const AnnouncementBanners: React.FC<AnnouncementBannerProps> = ({
  headerBanner,
}) => {
  let hardcodedBanner: HeaderBannerType | undefined;

  // The banner that we used after launching DRIP
  // hardcodedBanner = {
  //   content:
  //     "We've recently upgraded our website! Spot any bugs?\u00a0🐛 Email our team at hello@daymade.co.uk.",
  //   faIconName: 'wrench',
  //   tapHandler: null,
  // };

  return (
    <div>
      {hardcodedBanner && (
        <HeaderBanner bannerContent={hardcodedBanner} leftAligned={true} />
      )}

      {/* The banner that is passed in as a prop */}
      {headerBanner && (
        <HeaderBanner bannerContent={headerBanner} leftAligned={true} />
      )}
    </div>
  );
};

export default AnnouncementBanners;
